export default "__VITE_ASSET__TNUuT1dV__"